import Vue from 'vue'

import Storage from 'vue-ls';

const options = {
  namespace: 'vuejs__', // key prefix  // key键前缀
  name: 'ls', // name variable Vue.[ls] or this.[$ls], // 命名Vue变量.[ls]或this.[$ls],
  storage: 'session', // storage name session, local, memory // 存储名称: session, local, memory
};
Vue.use(Storage, options);



// WEBPACK FOOTER //
// ./src/plugins/vuels.js